module.exports = __webpack_public_path__ + "img/valued tools of the trade.a748d7a3.png";